import { render, staticRenderFns } from "./IndicadoresCatalogoListagemVendas.vue?vue&type=template&id=0a0cb1ce&"
import script from "./IndicadoresCatalogoListagemVendas.vue?vue&type=script&lang=js&"
export * from "./IndicadoresCatalogoListagemVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports